import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20golden%20and%20cream%20abstract%20background%20with%20soft%20gradient%20organic%20shapes%2C%20minimalist%20modern%20design%2C%20luxurious%20subtle%20texture%2C%20elegant%20flowing%20curves%2C%20warm%20amber%20and%20soft%20beige%20color%20palette%2C%20no%20text%2C%20clean%20artistic%20composition%2C%20high%20end%20aesthetic&width=1920&height=800&seq=hero-welfare-2026&orientation=landscape"
          alt="福利导航背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <i className="ri-sparkling-2-line text-primary-300"></i>
            <span className="text-sm text-background-50">
              每日更新 · 信息已核实 · 完全免费
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-5 leading-tight">
            发现属于你的
            <span className="relative inline-block mx-2">
              <span className="relative z-10 text-primary-300">福利资源</span>
              <span className="absolute bottom-1 left-0 right-0 h-3 bg-primary-500/30 rounded-full -z-0"></span>
            </span>
          </h1>

          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
            一站式福利资源聚合平台，汇聚折扣优惠、会员权益、生活补贴、职场福利等海量信息，
            帮助你快速找到最适合自己的福利资源，省时省力，轻松享受更多实惠与权益。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/discount"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-coupon-2-line mr-2"></i>
              浏览折扣优惠
            </Link>
            <Link
              to="/category/subsidy"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 font-medium text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-hand-heart-line mr-2"></i>
              查看生活补贴
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4 max-w-lg mx-auto">
            {[
              { num: '200+', label: '福利资源' },
              { num: '50万+', label: '月活跃用户' },
              { num: '99%', label: '信息准确率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50">
                  {stat.num}
                </div>
                <div className="text-xs text-background-300 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}